// extracted by mini-css-extract-plugin
module.exports = {"presenter":"VideoPresenter_presenter__1I9_y","presenterIcon":"VideoPresenter_presenterIcon__1EU9F"};